export const LOADING_SET = 'at/userProfile/teamList/LOADING_SET'
export const TEAM_NAMES_SET = 'at/userProfile/teamList/TEAM_NAMES_SET'
export const NEED_TO_LOAD_DATA_SET = 'at/userProfile/teamList/NEED_TO_LOAD_DATA_SET'



// WEBPACK FOOTER //
// ./web/js/userProfile/assignedTeamList/actionTypes.js